<template>
  <b-nav-item-dropdown
    id="dropdown-grouped"
    variant="link"
    class="dropdown-language"
    right
  >
    <template #button-content>
      <b-img
        :src="currentLocale.img"
        height="14px"
        width="22px"
        :alt="currentLocale.locale"
      />
      <span class="ml-50 text-body">{{ currentLocale.name }}</span>
    </template>
    <b-dropdown-item
      v-for="localeObj in locales"
      :key="localeObj.locale"
      @click="setaLocale(localeObj.locale)"
    >
      <b-img
        :src="localeObj.img"
        height="14px"
        width="22px"
        :alt="localeObj.locale"
      />
      <span class="ml-50">{{ localeObj.name }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem, BImg } from 'bootstrap-vue'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BImg,
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  computed: {
    currentLocale() {
      return this.locales.find(l => l.locale === this.$i18n.locale)
    },
  },
  methods: {
    setaLocale(val) {
      this.$i18n.locale = val
      localStorage.setItem('idioma', val)
      window.location.reload()
    }
  },
  setup() {
    /* eslint-disable global-require */
    const locales = [
    /*  {
        locale: 'pt',
        img: 'https://smartprotese.s3.sa-east-1.amazonaws.com/pt.png',
        name: 'Português',
      },*/
      {
        locale: 'pt-br',
        img: 'https://smartprotese.s3.sa-east-1.amazonaws.com/pt-br.png',
        name: 'Português',
      },
      {
        locale: 'en',
        img: 'https://smartprotese.s3.sa-east-1.amazonaws.com/en.png',
        name: 'English',
      },
      {
        locale: 'es',
        img: 'https://smartprotese.s3.sa-east-1.amazonaws.com/es.jpg',
        name: 'Español',
      },
      /* {
        locale: 'de',
        img: require('@/assets/images/flags/de.png'),
        name: 'German',
      }, */
    ]
    /* eslint-disable global-require */

    return {
      locales,
    }
  }
}
</script>

<style>
.dropdown-language {
  list-style: none !important;
}
.dropdown-language::before {
  content: none !important;
  display: none !important;
}

</style>
